import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { handlerChangeTabThreadChat } from '../handler/ChatThreadHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const DialogConfirmChangeTabChat = props => {
    useTranslationSubscription();
    const onHandlerCancel = () => {
        props.setIsOpenConfirmChangeThread(false);
    };

    const onHandlerConfirmChange = async () => {
        props.setIsOpenConfirmChangeThread(false);
        props.setIsEditedMsgInprogress(false);
        await handlerChangeTabThreadChat(props.changeToThread, props, props?.selectedProjectId);
    };

    return (
        <Dialog
            open={props.isOpenConfirmChangeThread}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">{trI18n('COMMSG048')}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    onClick={onHandlerConfirmChange}
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                >
                    {trI18n('COMBTN002')}
                </Button>

                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={onHandlerCancel}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
